<script lang="ts">
    import type {OdEditModalManager} from "./OdEditModalManager";
    import {get} from "svelte/store";

    export let manager: OdEditModalManager;
    export let i: number;

    let nameStore = manager.getNameStore(i);
    let name = $nameStore;
    nameStore.subscribe(n => {
       name = n;
    });

    function onFocusOut(): void {
        const oldValue = get(manager.getNameStore(i));
        if (oldValue == name) return;

        manager.setName(i, name);
    }
</script>

<th class="text-muted width">
    <input type="text" bind:value={name} class="w-100 border-0 text-center" on:focusout={onFocusOut}/>
</th>

<style>
    .width {
        min-width: 65px;
    }
</style>
